module.exports = {
  stringPatterns: [
    /'[^]*?'/g,
    /"[^]*?"/g,
    /`[^]*?`/g
  ],

  prePatterns: [
    /\[[^]*?\]/,
    /{[^]*?}/,
    /=>\s*?\([^]*?\)/,
    /=\s*?function\s*?\([^]*(?=[^]*\))/,
    /=\s*?\([^]*(?=[^]*\))/,
    /\s*?=[^>][^,\)]*/
  ],

  postPatterns: [
    /\([^]*?\)/,
  ]
}
